import React from "react";
import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import Logo from "Pages/Components/Logo";
import { FONT_SANS, PURPLE } from "./checkoutV2.constants";

/** Asset served from `public/DonatePage/`. */
const asset = (file: string) => `${process.env.PUBLIC_URL}/DonatePage/${file}`;

/** Gold Transparency / Candid seal. */
const TRANSPARENCY_BADGE = asset("Group14.png");
/** Apple App Store badge. */
const APP_STORE_BADGE = asset("Group.png");
/** Google Play badge. */
const GOOGLE_PLAY_BADGE = asset("Group1.png");

const InstagramIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1278_7761)">
      <path d="M12 2.163C15.204 2.163 15.584 2.175 16.85 2.233C20.102 2.381 21.621 3.924 21.769 7.152C21.827 8.417 21.838 8.797 21.838 12.001C21.838 15.206 21.826 15.585 21.769 16.85C21.62 20.075 20.105 21.621 16.85 21.769C15.584 21.827 15.206 21.839 12 21.839C8.796 21.839 8.416 21.827 7.151 21.769C3.891 21.62 2.38 20.07 2.232 16.849C2.174 15.584 2.162 15.205 2.162 12C2.162 8.796 2.175 8.417 2.232 7.151C2.381 3.924 3.896 2.38 7.151 2.232C8.417 2.175 8.796 2.163 12 2.163ZM12 0C8.741 0 8.333 0.014 7.053 0.072C2.695 0.272 0.273 2.69 0.073 7.052C0.014 8.333 0 8.741 0 12C0 15.259 0.014 15.668 0.072 16.948C0.272 21.306 2.69 23.728 7.052 23.928C8.333 23.986 8.741 24 12 24C15.259 24 15.668 23.986 16.948 23.928C21.302 23.728 23.73 21.31 23.927 16.948C23.986 15.668 24 15.259 24 12C24 8.741 23.986 8.333 23.928 7.053C23.732 2.699 21.311 0.273 16.949 0.073C15.668 0.014 15.259 0 12 0ZM12 5.838C11.1908 5.838 10.3895 5.99739 9.6419 6.30705C8.8943 6.61672 8.215 7.07061 7.64281 7.64281C7.07061 8.215 6.61672 8.8943 6.30705 9.6419C5.99738 10.3895 5.838 11.1908 5.838 12C5.838 12.8092 5.99738 13.6105 6.30705 14.3581C6.61672 15.1057 7.07061 15.785 7.64281 16.3572C8.215 16.9294 8.8943 17.3833 9.6419 17.6929C10.3895 18.0026 11.1908 18.162 12 18.162C13.6343 18.162 15.2016 17.5128 16.3572 16.3572C17.5128 15.2016 18.162 13.6343 18.162 12C18.162 10.3657 17.5128 8.79841 16.3572 7.64281C15.2016 6.48721 13.6343 5.838 12 5.838ZM12 16C10.9391 16 9.92172 15.5786 9.17157 14.8284C8.42143 14.0783 8 13.0609 8 12C8 10.9391 8.42143 9.92172 9.17157 9.17157C9.92172 8.42143 10.9391 8 12 8C13.0609 8 14.0783 8.42143 14.8284 9.17157C15.5786 9.92172 16 10.9391 16 12C16 13.0609 15.5786 14.0783 14.8284 14.8284C14.0783 15.5786 13.0609 16 12 16ZM18.406 4.155C18.2168 4.155 18.0295 4.19226 17.8547 4.26465C17.68 4.33704 17.5212 4.44315 17.3874 4.57691C17.2537 4.71068 17.1475 4.86947 17.0752 5.04424C17.0028 5.21901 16.9655 5.40633 16.9655 5.5955C16.9655 5.78467 17.0028 5.97199 17.0752 6.14676C17.1475 6.32153 17.2537 6.48032 17.3874 6.61409C17.5212 6.74785 17.68 6.85396 17.8547 6.92635C18.0295 6.99874 18.2168 7.036 18.406 7.036C18.788 7.036 19.1544 6.88423 19.4246 6.61409C19.6947 6.34394 19.8465 5.97754 19.8465 5.5955C19.8465 5.21346 19.6947 4.84706 19.4246 4.57691C19.1544 4.30677 18.788 4.155 18.406 4.155Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_1278_7761">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const FacebookIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1278_7764)">
      <path d="M22.675 0H1.325C0.593 0 0 0.593 0 1.325V22.676C0 23.407 0.593 24 1.325 24H12.82V14.706H9.692V11.084H12.82V8.413C12.82 5.313 14.713 3.625 17.479 3.625C18.804 3.625 19.942 3.724 20.274 3.768V7.008L18.356 7.009C16.852 7.009 16.561 7.724 16.561 8.772V11.085H20.148L19.681 14.707H16.561V24H22.677C23.407 24 24 23.407 24 22.675V1.325C24 0.593 23.407 0 22.675 0Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_1278_7764">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

interface NavItem {
  /** i18n key for the link label. */
  textKey: string;
  /** Internal route (react-router). */
  to?: string;
  /** External URL. */
  url?: string;
}

interface NavColumn {
  /** i18n key for the column heading. */
  titleKey: string;
  items: NavItem[];
}

const NAV_COLUMNS: NavColumn[] = [
  {
    titleKey: "footer.company",
    items: [
      { textKey: "footer.about", to: "/about" },
      { textKey: "footer.contact", to: "/contact" },
      { textKey: "footer.blog", to: "/blog" },
      { textKey: "footer.helpCenter", to: "/help" },
    ],
  },
  {
    titleKey: "footer.supportUs",
    items: [
      { textKey: "footer.donate", to: "/donate" },
      {
        textKey: "footer.donateACar",
        url: "https://careasy.org/nonprofit/foundationtoadvancejazzjazzgroove",
      },
    ],
  },
  {
    titleKey: "footer.otherLinks",
    items: [
      { textKey: "footer.listen", to: "/" },
      { textKey: "footer.devices", to: "/devices" },
    ],
  },
];

const linkSx = {
  fontFamily: FONT_SANS,
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "24px",
  color: "common.white",
  textDecoration: "none",
  // "&:hover": {
  //   color: PURPLE,
  //   textDecoration: "none",
  // },
};

const headingSx = {
  fontFamily: "DM Sans",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "27px",
  letterSpacing: "-0.44px",
  textTransform: "uppercase",
  color: "rgba(255,255,255)",
};

const NavColumnBlock = ({ column }: { column: NavColumn }) => {
  const { t } = useTranslation();
  return (
  <Box sx={{ minWidth: {xs: 163, sm: 102} }}>
    <Typography sx={headingSx}>{t(column.titleKey)}</Typography>
    <Box sx={{ display: "flex", flexDirection: "column", gap: "1px" }}>
      {column.items.map((item) =>
        item.to ? (
          <Link key={item.textKey} component={RouterLink} to={item.to} sx={linkSx}>
            {t(item.textKey)}
          </Link>
        ) : (
          <Link
            key={item.textKey}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            sx={linkSx}
          >
            {t(item.textKey)}
          </Link>
        )
      )}
    </Box>
  </Box>
  );
};

/**
 * Donate page (CheckoutV2) footer. Three-part layout — brand/contact on the
 * left, link columns in the middle, co-browse on the right — above a purple
 * legal bar. Matches the redesign spec rather than the legacy {@link Footer}.
 */
const FooterV2 = () => {
  const { t } = useTranslation();
  const coBrowseCode = "1118";

  return (
    <Box component="footer" sx={{ backgroundColor: "#1E1E1E" }}>
      <Box sx={{ p: {xs: 3, md: 4} }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: { xs: "center", md: "space-between" },
            gap: { xs: 3, md: 4 },
          }}
        >
          {/* LEFT — brand, social, contact */}
          <Box sx={{ maxWidth: {xs: 246, md: 197}, margin: { xs: "0 auto", md: 0 }, textAlign: { xs: "center", md: "left" } }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: {xs: 3 ,md: 2.5} ,justifyContent: { xs: "center", md: "flex-start" } }}>
              <Logo height="46px" width={101} monochrome />
              <Box
                component="img"
                src={TRANSPARENCY_BADGE}
                alt={t("footer.altCandid")}
                sx={{ height: 47, width: "auto" }}
              />
            </Box>

            <Typography
              sx={{
                fontFamily: FONT_SANS,
                fontSize: "14px",
                lineHeight: 1.5,
                color: "common.white",
                mt: { xs: 3, md: 1 },
              }}
            >
              <Trans
                i18nKey="footer.nonprofitBlurb"
                components={{
                  1: <Box component="span" sx={{ whiteSpace: "nowrap" }} />,
                }}
              />
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: { xs: 3, md: 2 }, justifyContent: { xs: "center", md: "flex-start" } }}>
              <Link
                href="https://www.instagram.com/JazzGroove1/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("footer.ariaInstagram")}
                sx={{ lineHeight: 0 }}
              >
                <InstagramIcon />
              </Link>
              <Link
                href="https://www.facebook.com/TheJazzGroove"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("footer.ariaFacebook")}
                sx={{ lineHeight: 0 }}
              >
                <FacebookIcon />
              </Link>
            </Box>

            <Typography
              sx={{
                fontFamily: FONT_SANS,
                fontSize: "12px",
                lineHeight:"16px",
                letterSpacing: "-0.31px",
                color: "common.white",
                mt: { xs: 3, md: 1 },
              }}
            >
              {t("footer.callUs")}
            </Typography>

              <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center", gap: 1.5, mt: 2, justifyContent: { xs: "center", md: "flex-start" } }}>
                <Link
                  href="https://apps.apple.com/us/app/the-jazz-groove/id1359980261"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t("footer.ariaAppStore")}
                  sx={{ lineHeight: 0 }}
                >
                  <Box
                    component="img"
                    src={APP_STORE_BADGE}
                    alt={t("footer.ariaAppStore")}
                    sx={{ height: 24, width: "auto" }}
                  />
                </Link>
                <Link
                  href="https://play.google.com/store/apps/details?id=com.thejazzgroove.radio&hl=en_US&gl=US"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t("footer.ariaGooglePlay")}
                  sx={{ lineHeight: 0 }}
                >
                  <Box
                    component="img"
                    src={GOOGLE_PLAY_BADGE}
                    alt={t("footer.ariaGooglePlay")}
                    sx={{ height: 24, width: "auto" }}
                  />
                </Link>
              </Box>
          </Box>

          <Box
            sx={{
              height: "1px",
              backgroundColor: "#FFFFFF1A",
              display: { xs: "block", md: "none" },
            }}
          />

          {/* MIDDLE — link columns */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: { xs: "center", sm: "space-between" },
              maxWidth: 402,
              textAlign: { xs: "center", md: "left" },
              margin: { xs: "0 auto", md: 0 },
              width: "100%",
              rowGap: { xs: 2.5, md: 0 },
            }}
          >
            {NAV_COLUMNS.map((column) => (
              <NavColumnBlock key={column.titleKey} column={column} />
            ))}
          </Box>

          <Box
            sx={{
              height: "1px",
              backgroundColor: "#FFFFFF1A",
              display: { xs: "block", md: "none" },
            }}
          />

          {/* RIGHT — co-browse */}
          <Box sx={{ maxWidth: {xs: "100%", md: 229}, margin: { xs: "0 auto", md: 0 }, textAlign: { xs: "center", md: "left" } }}>
            <Typography sx={headingSx} mb={1}>{t("footer.coBrowse")}</Typography>
            <Typography
              sx={{
                fontFamily: "DM Sans",
                fontSize: "12px",
                lineHeight:"24px",
                letterSpacing: "-0.31px",
                fontWeight: 600,
                color: "common.white",
                mb: "9px",
              }}
            >
              {coBrowseCode}
            </Typography>
            <Typography
              sx={{
                fontFamily: "DM Sans",
                fontSize: "12px",
                lineHeight:"16px",
                letterSpacing: "-0.31px",
                color: "common.white",
              }}
            >
              {t("footer.coBrowseNote")}
            </Typography>
          </Box>

          <Box
            sx={{
              height: "1px",
              backgroundColor: "#FFFFFF1A",
              display: { xs: "block", md: "none" },
            }}
          />

          <Box sx={{ display: { xs: "flex", md: "none" }, alignItems: "center", gap: 1.5, justifyContent: { xs: "center", md: "flex-start" } }}>
            <Link
              href="https://apps.apple.com/us/app/the-jazz-groove/id1359980261"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t("footer.ariaAppStore")}
              sx={{ lineHeight: 0 }}
            >
              <Box
                component="img"
                src={APP_STORE_BADGE}
                alt={t("footer.ariaAppStore")}
                sx={{ height: 24, width: "auto" }}
              />
            </Link>
            <Link
              href="https://play.google.com/store/apps/details?id=com.thejazzgroove.radio&hl=en_US&gl=US"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t("footer.ariaGooglePlay")}
              sx={{ lineHeight: 0 }}
            >
              <Box
                component="img"
                src={GOOGLE_PLAY_BADGE}
                alt={t("footer.ariaGooglePlay")}
                sx={{ height: 24, width: "auto" }}
              />
            </Link>
          </Box>

        </Box>
      </Box>

      {/* PURPLE legal bar */}
      <Box sx={{ backgroundColor: PURPLE }}>
        <Box sx={{ py: { xs: "14px", md: "16px" }, px: { xs: "24px", md: "32px" } }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              justifyContent: "space-between",
              gap: {xs:1.3, md: 2},
              // py: 2.5,
            }}
          >
            <Typography
              sx={{
                fontFamily: FONT_SANS,  
                fontSize: {xs:"11px", md: "14px"},
                textAlign: { xs: "center", sm: "left" },
                color: "common.white",
                // textAlign: { xs: "center", sm: "left" },
              }}
            >
              {t("footer.copyright", { year: new Date().getFullYear() })}
            </Typography>

              <Box
                sx={{
                  height: "1px",
                  width: "100%",
                  backgroundColor: "#FFFFFF40",
                  display: { xs: "block", md: "none" },
                }}
              />

            <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
              <Link component={RouterLink} to="/privacy-policy" sx={linkSx}>
                {t("footer.privacyPolicy")}
              </Link>
              <Link
                href="https://www.websitepolicies.com/policies/view/VuSlcfN6"
                target="_blank"
                rel="noopener noreferrer"
                sx={linkSx}
              >
                {t("footer.termsOfService")}
              </Link>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FooterV2;
